import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import EditBuyerInfoModal from '../../../../views/order/common/modal/EditBuyerInfoModal';
import { orderActions } from '../../../../store/modules/order';
import { isBlank, setTrim } from '../../../../lib/common';
import withModal from '../../../../lib/hoc/withModal';

class EditBuyerInfoModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      /**
       *  상품 주문 id
       */
      orderItemId: this.props.data.orderItemId,
      /**
       *  수취인명
       */
      recipientName: this.props.data.recipientName,
      /**
       *  수취인 연락처
       */
      recipientPhone: this.props.data.recipientPhone,
      /**
       *  배송지
       */
      shippingAddress: {
        postCode: this.props.data.address.postCode,
        city: this.props.data.address.city,
        line1: this.props.data.address.line1,
        line2: this.props.data.address.line2,
      },
      /**
       *  배송 시 요청사항
       */
      shippingMessage: this.props.data.shippingMessage,
    };
  }

  /**
   * 모달 닫기 || 데이터 초기화
   */
  closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal({
      name: 'editBuyerInfoModal',
    });
  };

  /**
   * 주문자 정보 수정하기
   */
  onSubmit = () => {
    const { form, editBuyerInfo } = this.props;
    const { orderItemId, recipientName, recipientPhone, shippingAddress, shippingMessage } = this.state;

    form.validateFields((err) => {
      if (err) return;

      editBuyerInfo({
        orderItemId,
        recipientName,
        recipientPhone: recipientPhone.split('-').join(''),
        shippingAddress,
        shippingMessage: !isBlank(setTrim(shippingMessage)) ? setTrim(shippingMessage) : '',
      });

      this.closeModal();
    });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  setShippingAddress = (data) => {
    this.setState({
      [data.name]: {
        ...this.state.shippingAddress,
        ...data.value,
      },
    });
  };

  render() {
    const { isOpen, form, data } = this.props;

    return (
      <EditBuyerInfoModal
        form={form}
        isOpen={isOpen}
        isGiftReady={data.isGiftReady}
        {...this.state}
        onSubmit={this.onSubmit}
        setData={this.setData}
        setShippingAddress={this.setShippingAddress}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.order.editBuyerInfoModal.isOpen,
    data: state.order.editBuyerInfoModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: orderActions.toggleModal,
  editBuyerInfo: orderActions.editBuyerInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(Form.create({})(EditBuyerInfoModalContainer)));
